/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const encryptValue = /* GraphQL */ `
  query EncryptValue($input: String!) {
    encryptValue(input: $input) {
      data
      error
    }
  }
`;
export const getAvailabilityFileContent = /* GraphQL */ `
  query GetAvailabilityFileContent($key: String!, $sub: String!) {
    getAvailabilityFileContent(key: $key, sub: $sub) {
      ContentLength
      ContentType
      ETag
      contents
    }
  }
`;
export const getAvailabilityFileList = /* GraphQL */ `
  query GetAvailabilityFileList(
    $continuationToken: String
    $startAfter: String
    $sub: String!
  ) {
    getAvailabilityFileList(
      continuationToken: $continuationToken
      startAfter: $startAfter
      sub: $sub
    ) {
      Contents {
        ETag
        Key
        LastModified
        Size
      }
      IsTruncated
      KeyCount
      MaxKeys
      Name
      NextContinuationToken
    }
  }
`;
export const getLinks = /* GraphQL */ `
  query GetLinks($sub: String!) {
    getLinks(sub: $sub) {
      accCount
      accounts {
        accountId
        baseUrl
        encryptedPassword
        mh1EasyRecalls {
          pmsSiteId
        }
        notificationChannel
        olbBooks {
          olbBookId
          pmsBookFQId
          treatmentMappings {
            olbTreatmentId
            pmsAppointmentTypeId
          }
          appointmentTypes {
            name
          }
        }
        platform
        primaryPmsSiteId
        products
        timeZone
        username
      }
      ctd
      ctdTs
      sub
    }
  }
`;
export const getLogs = /* GraphQL */ `
  query GetLogs(
    $endTime: AWSTimestamp
    $nextToken: String
    $startTime: AWSTimestamp
    $sub: String!
  ) {
    getLogs(
      endTime: $endTime
      nextToken: $nextToken
      startTime: $startTime
      sub: $sub
    ) {
      events {
        ingestionTime
        message
        timestamp
      }
      nextBackwardToken
      nextForwardToken
    }
  }
`;
export const getMh1PracticeAppointmentBooks = /* GraphQL */ `
  query GetMh1PracticeAppointmentBooks($practiceId: Int) {
    getMh1PracticeAppointmentBooks(practiceId: $practiceId) {
      id
      minimumSlotsPerTreatment
      slotSize
      status
      subscriber {
        gender
        id
        name
        pmsLocation
        pmsPractitionerCode
        surname
      }
      timeZone
      workingHours {
        friday {
          enabled
          end
          start
        }
        monday {
          enabled
          end
          start
        }
        saturday {
          enabled
          end
          start
        }
        sunday {
          enabled
          end
          start
        }
        thursday {
          enabled
          end
          start
        }
        tuesday {
          enabled
          end
          start
        }
        wednesday {
          enabled
          end
          start
        }
      }
    }
  }
`;
export const getMh1PracticeDetails = /* GraphQL */ `
  query GetMh1PracticeDetails($practiceId: Int) {
    getMh1PracticeDetails(practiceId: $practiceId) {
      addressLine1
      addressLine2
      city
      country
      latitude
      longitude
      name
      postCode
      practiceId
      state
    }
  }
`;
export const getMh1PracticeTreatments = /* GraphQL */ `
  query GetMh1PracticeTreatments(
    $includeDisabledTreatments: Boolean
    $practiceId: Int!
  ) {
    getMh1PracticeTreatments(
      includeDisabledTreatments: $includeDisabledTreatments
      practiceId: $practiceId
    ) {
      appointmentBooks {
        appointmentBookId
        practitionerName
        practitionerSurname
        treatments {
          appointmentBookTreatmentId
          duration
          enabled
          isGlobal
          name
          treatmentId
        }
      }
      name
      practiceId
    }
  }
`;
export const getMh1ServiceTypes = /* GraphQL */ `
  query GetMh1ServiceTypes {
    getMh1ServiceTypes {
      canBeSearched
      dateCreated
      defaultType
      displayInEh1
      id
      isSpecialist
      lastUpdated
      name
      orderBy
      telehealthOnly
      urlAlias
    }
  }
`;
export const getPmsInfo = /* GraphQL */ `
  query GetPmsInfo($sub: String!) {
    getPMSInfo(sub: $sub) {
      appVersion
      brand
      ctd
      ctdTs
      details
      pmsStatus
      pmsType
      pmsVersion
      sub
      s3Link
      usr
    }
  }
`;
export const getStatus = /* GraphQL */ `
  query GetStatus($sub: String!) {
    getStatus(sub: $sub) {
      availabilityLastInS3Key
      availabilityLastOutS3Key
      availabilityLastProcTs
      availabilityLastRcvdTs
      brand
      ctd
      ctdTs
      heartbeatRcvd
      linkedAccountCount
      pmsStatus
      pmsType
      pmsVersion
      sub
      typ
      usr
    }
  }
`;
export const listHeartbeats = /* GraphQL */ `
  query ListHeartbeats(
    $filter: ListHeartbeatsFilter
    $limit: Int
    $nextToken: String
  ) {
    listHeartbeats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        appVersion
        ctd
        ctdTs
        dotNet
        exeName
        exePath
        lastReadFromPms
        pmsStatus
        pmsType
        pmsVersion
        processId
        processUptime
        sip
        sub
        systemIp
        systemName
        systemOs
        ttl
        usr
      }
      nextToken
    }
  }
`;
export const listStatusByProvisionTs = /* GraphQL */ `
  query ListStatusByProvisionTs(
    $filter: ListStatusByProvisionTsFilter
    $limit: Int
    $nextToken: String
  ) {
    listStatusByProvisionTs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        appVersion
        availabilityLastProcTs
        availabilityLastRcvdTs
        brand
        ctd
        ctdTs
        heartbeatRcvd
        pmsStatus
        pmsType
        pmsVersion
        sub
        usr
      }
      nextToken
    }
  }
`;
export const searchMh1Practices = /* GraphQL */ `
  query SearchMh1Practices(
    $modality: Int
    $pmsType: Int
    $practiceName: String!
  ) {
    searchMh1Practices(
      modality: $modality
      pmsType: $pmsType
      practiceName: $practiceName
    ) {
      address1
      address2
      city
      dateCreated
      email
      enabled
      id
      latitude
      longitude
      name
      phone
      pms {
        id
        name
      }
      postcode
      serviceType {
        id
        name
      }
      state
    }
  }
`;
export const searchStatus = /* GraphQL */ `
  query SearchStatus(
    $filter: SearchStatusFilter
    $limit: Int
    $nextToken: String
  ) {
    searchStatus(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        appVersion
        availabilityLastProcTs
        availabilityLastRcvdTs
        brand
        ctd
        ctdTs
        heartbeatRcvd
        pmsStatus
        pmsType
        pmsVersion
        sub
        usr
      }
      nextToken
    }
  }
`;
